import {DichopticAssetKey} from 'core/api/prescription'

export const DEMO_DICHOPTIC_MASKS = [{
  amblyopic: '/dichoptic-mask/2017-08-05-A-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2017-08-05-A-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2017-08-05-B-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2017-08-05-B-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2017-08-05-C-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2017-08-05-C-F.png' as DichopticAssetKey,
}]

export const CAM1C_DICHOPTIC_MASKS = [{
  amblyopic: '/dichoptic-mask/2017-08-05-A-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2017-08-05-A-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2017-08-05-B-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2017-08-05-B-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2017-08-05-C-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2017-08-05-C-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2017-08-05-D-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2017-08-05-D-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2017-08-05-E-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2017-08-05-E-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2017-08-05-F-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2017-08-05-F-F.png' as DichopticAssetKey,
}]

/**
 * Dichoptic mask assets introduced in C-AM-1D.
 *
 * Created according to Dean Travers on 2017-09-21
 */
export const CAM1D_DICHOPTIC_MASKS = [
  {
    amblyopic: '/dichoptic-mask/2017-09-21-A-A.png' as DichopticAssetKey,
    fellow:    '/dichoptic-mask/2017-09-21-A-F.png' as DichopticAssetKey,
  }, {
    amblyopic: '/dichoptic-mask/2017-09-21-B-A.png' as DichopticAssetKey,
    fellow:    '/dichoptic-mask/2017-09-21-B-F.png' as DichopticAssetKey,
  }, {
    amblyopic: '/dichoptic-mask/2017-09-21-C-A.png' as DichopticAssetKey,
    fellow:    '/dichoptic-mask/2017-09-21-C-F.png' as DichopticAssetKey,
  }, {
    amblyopic: '/dichoptic-mask/2017-09-21-D-A.png' as DichopticAssetKey,
    fellow:    '/dichoptic-mask/2017-09-21-D-F.png' as DichopticAssetKey,
  }, {
    amblyopic: '/dichoptic-mask/2017-09-21-E-A.png' as DichopticAssetKey,
    fellow:    '/dichoptic-mask/2017-09-21-E-F.png' as DichopticAssetKey,
  }, {
    amblyopic: '/dichoptic-mask/2017-09-21-F-A.png' as DichopticAssetKey,
    fellow:    '/dichoptic-mask/2017-09-21-F-F.png' as DichopticAssetKey,
  }, {
    amblyopic: '/dichoptic-mask/2017-09-21-G-A.png' as DichopticAssetKey,
    fellow:    '/dichoptic-mask/2017-09-21-G-F.png' as DichopticAssetKey,
  }, {
    amblyopic: '/dichoptic-mask/2017-09-21-H-A.png' as DichopticAssetKey,
    fellow:    '/dichoptic-mask/2017-09-21-H-F.png' as DichopticAssetKey,
  }, {
    amblyopic: '/dichoptic-mask/2017-09-21-I-A.png' as DichopticAssetKey,
    fellow:    '/dichoptic-mask/2017-09-21-I-F.png' as DichopticAssetKey,
  }, {
    amblyopic: '/dichoptic-mask/2017-09-21-J-A.png' as DichopticAssetKey,
    fellow:    '/dichoptic-mask/2017-09-21-J-F.png' as DichopticAssetKey,
  }, {
    amblyopic: '/dichoptic-mask/2017-09-21-K-A.png' as DichopticAssetKey,
    fellow:    '/dichoptic-mask/2017-09-21-K-F.png' as DichopticAssetKey,
  },
]



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/prescription/treatment/cycles/dichoptic-masks.ts